import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import Heading from '@components/Heading/Heading';
import { INavigationVirtualCategory } from '@features/categories';
import styles from '@features/categories/components/NavigationVirtualCategories/NavigationVirtualCategories.styles';
type PropsType = {
  navigationVirtualCategories: INavigationVirtualCategory[];
};
const NavigationVirtualCategories = ({
  navigationVirtualCategories
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  return <>
      <section sx={styles.section}>
        <div sx={styles.container}>
          <Heading h={4} pb={18}>
            {t('seeAlso')}
          </Heading>
          <div sx={styles.linkContainer}>
            {Object.keys(navigationVirtualCategories).map(key => <div key={`${navigationVirtualCategories[key].title}-${Math.random()}`}>
                <Link href={navigationVirtualCategories[key].slug}>{navigationVirtualCategories[key].title}</Link>
              </div>)}{' '}
          </div>
        </div>
      </section>
    </>;
};
export default NavigationVirtualCategories;